export const enum CreditRequestStatus {
  NOT_CREATED = 0,
  CREATED_NOT_SENT = 1,
  SENT = 2,
  RECEIVED = 3,
  REVIEWED = 4,
  APPROVED = 5,
  REJECTED = 6
}

export const creditRequestStatuses = [
  CreditRequestStatus.NOT_CREATED,
  CreditRequestStatus.CREATED_NOT_SENT,
  CreditRequestStatus.SENT,
  CreditRequestStatus.RECEIVED,
  CreditRequestStatus.REVIEWED,
  CreditRequestStatus.APPROVED,
  CreditRequestStatus.REJECTED,
];

export const creditRequestStatusTranslationMap = {
  [CreditRequestStatus.NOT_CREATED]: 'creditRequest.status.notCreated',
  [CreditRequestStatus.CREATED_NOT_SENT]: 'creditRequest.status.createdNotSent',
  [CreditRequestStatus.SENT]: 'creditRequest.status.sent',
  [CreditRequestStatus.RECEIVED]: 'creditRequest.status.received',
  [CreditRequestStatus.REVIEWED]: 'creditRequest.status.reviewed',
  [CreditRequestStatus.APPROVED]: 'creditRequest.status.approved',
  [CreditRequestStatus.REJECTED]: 'creditRequest.status.rejected',
};
